import { Box, Collapse, Text, useDisclosure, Flex } from '@chakra-ui/react'
import { TriangleDownIcon, TriangleUpIcon, InfoIcon } from '@chakra-ui/icons'
import { FC, ReactNode } from 'react'
import BlueButton from '../button-blue'

interface InfoToggleButtonProps {
  title: string
  children: ReactNode
}

const InfoToggleButton: FC<InfoToggleButtonProps> = ({ title, children }) => {
  const { isOpen, onToggle } = useDisclosure()

  return (
    <Box bg='gray.50' p={3} borderRadius='md' width='100%' maxWidth='600px' mb={4} boxShadow='sm'>
      <Flex align='center' gap={2}>
        <InfoIcon color='blue.500' />
        <Text fontWeight='semibold' fontSize='sm'>
          {title}
        </Text>

        <BlueButton onClick={onToggle} bgColor='blue' size='xs' variant='ghost' ml='auto'>
          {isOpen ? <TriangleUpIcon color='blue.500' /> : <TriangleDownIcon color='blue.500' />}
        </BlueButton>
      </Flex>

      <Collapse in={isOpen} animateOpacity>
        <Box mt={2} pl={6}>
          <Text fontSize='sm' color='gray.700'>
            {children}
          </Text>
        </Box>
      </Collapse>
    </Box>
  )
}

export default InfoToggleButton
